import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Icon from './Navbar.css';

import './Header.css';

function Navbar() {

  // VIEW
  return (
    <div className='sticky-top'>
      {/* Header */}
      <header className="navbar navbar-expand-md navbar-dark Navbar_dark sticky-top d-print-none">
        <div className="container-fluid">
          {/* leftside */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbar-menu"
          >
            <span className="navbar-toggler-icon" />
          </button>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img
              src={`${process.env.PUBLIC_URL}/static/logo_kopkar.png`}
              style={{ width: '42px', height: '42px', marginRight: '5px' }}
              alt="logo"
            />
            <h5 className="navbar-brand navbar-brand-autodark d-none-navbar-horizontal pe-0 pe-md-3" style={{ fontSize: 20, color: "#CD5C08", margin: '0', marginLeft: '0' }}>
              Koperasi Karyawan Aerospace Bandung
            </h5>
          </div>

        </div>
      </header>

    </div>

  );
}

export default Navbar;
